<script lang="ts" module>
  import { Label, Switch, type SwitchRootProps } from 'bits-ui';
  import { tv } from 'tailwind-variants';

  const styles = tv({
    slots: {
      root: 'h-[10px] w-[20px] rounded-[5px] bg-switch transition-colors',
      thumb: 'block size-[6px] translate-x-[2px] rounded-[5px] bg-white transition-transform',
      label: 'mr-1 text-label-xs transition-colors',
    },
    variants: {
      checked: {
        true: { root: 'bg-switch-S', thumb: '!translate-x-[12px]' },
      },
      disabled: {
        true: { root: 'bg-switch-disabled', label: 'text-c-disabled' },
      },
    },
  });
</script>

<script lang="ts">
  let {
    checked = $bindable(),
    disabled = false,
    label,
    id,
    ...props
  }: {
    checked: boolean;
    disabled?: boolean;
    label?: string;
    id?: string;
  } & SwitchRootProps = $props();

  let { root: rootCn, thumb: thumbCn, label: labelCn } = $derived(styles({ checked, disabled }));
</script>

<div class="flex items-center space-x-1">
  <Label.Root for={id} class={labelCn()}>{label}</Label.Root>
  <Switch.Root {id} bind:checked {disabled} class={rootCn()} {...props}>
    <Switch.Thumb class={thumbCn()} />
  </Switch.Root>
</div>
